module.exports = __webpack_public_path__ + "img/ethoca-clarity-matching-guidance.fa7eb94d.png";